import React, { useState, useEffect } from "react";
import Logo from '../../assets/Images/Docusafe_logo.webp';

const Header = (props) => {
    const [dueDays, setDueDays] = useState(0);
    const [totalDoc, setTotalDoc] = useState(0);

    useEffect(function () {
        if (props?.envelopeData?.due_days) {
            setDueDays(parseInt(props?.envelopeData?.due_days));
        }
        let totalDoc = 0;
        if (props?.envelopeData?.document_list) {
            totalDoc = props?.envelopeData?.document_list.length;
        }
        let totalForm = 0;
        if (props?.envelopeData?.request_form_list) {
            totalForm = props?.envelopeData?.request_form_list.length;
        }
        let totalSignDoc = 0;
        if (props?.envelopeData?.sign_documents) {
            totalSignDoc = props?.envelopeData?.sign_documents.length;
        }
        setTotalDoc(totalDoc + totalForm + totalSignDoc);
    }, [props?.envelopeData]);

    return (
        <nav className="navbar navbar-expand-lg shadow-md">
            <div className="d-flex align-items-center justify-content-between w-100 px-3">
                <div>
                    <span className="navbar-brand">
                        <img src={Logo} alt="" className="docusafe_logo" />
                    </span>
                </div>
                <div className="ms-auto navbar_client">
                    <div className="d-flex align-items-center w-100 justify-content-end flex_wrap">
                        {props.envelopeData && !props.envelopeData?.is_finish &&
                            <p className="due_days d-flex justify-content-center align-items-center mb-0 fw-bolder">
                                <img src="/images/clock.webp" className="me-2"
                                    alt="..." /> {dueDays >= 0 ? `Due in ` : `Overdue by `} {Math.abs(dueDays)} Days
                            </p>
                        }
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
